import { useTranslation } from "react-i18next";

import { Row } from "react-bootstrap";

export default function TechAreaHelper({
  searchObject,
  onChange,
  techAreaList,
  techRoleList,
  setHelperOpen
}) {
  const { t } = useTranslation();
  //const { setHelperOpen } = useJobRoleDetailsContext();

  return (
    <Row>
      <div className="col-md-6">
        <legend className="fontsize-legend">
          {t("Tech Area")}{" "}
          <a
            className="col text-end"
            href="#"
            onClick={() => setHelperOpen(true)}
          >
            {t("View Categorization")}
          </a>
        </legend>{" "}
        <select
          className="form-select fontsize-legend"
          name="techAreaId"
          id="techAreaId"
          onChange={onChange}
          value={searchObject.techAreaId || ""}
        >
          <option></option>
          {techAreaList?.map((techArea) => (
            <option
              className="fontsize-legend"
              key={techArea.id}
              value={techArea.id}
            >
              {t(techArea.description)}
            </option>
          ))}
        </select>
      </div>
      <div className="col-md-6">
        <legend className="fontsize-legend">{t("Tech Role")}</legend>{" "}
        <select
          className="form-select fontsize-legend"
          name="techRoleId"
          id="techRoleId"
          onChange={onChange}
          value={searchObject.techRoleId || ""}
        >
          <option></option>
          {techRoleList?.map((techRole) => (
            <option
              className="fontsize-legend"
              key={techRole.id}
              value={techRole.id}
            >
              {t(techRole.description)}
            </option>
          ))}
        </select>
      </div>
    </Row>
  );
}
